module.exports = __webpack_public_path__ + "static/media/download.742f66cf.svg";